import React, { FC } from 'react';
import styles from './ToggleOptions.module.css';

export class ToggleOption {
    title: string;
    value: any;
}

interface ToggleOptionsProps {
    label: string,
    options: ToggleOption[],
    setOptions: (options: ToggleOption[]) => void,
}

const ToggleOptions: FC<ToggleOptionsProps> = ({ label, options, setOptions }) => (
    <div className={styles.ToggleOptions} data-testid="ToggleOptions">
        <div className={`${styles.flatLabel}`}>
            <label>{label}</label>
        </div>
        <div className={styles.opt}>
            {
                options.map((option, index) =>
                    <button className={`${styles.option} ${option.value ? styles.active : ''}`} key={index}
                        onClick={() => {
                            const opts = [...options.map(o => {
                                if (o === option) {
                                    o.value = !o.value;
                                    return { ...o };
                                } else {
                                    return { ...o };
                                }
                            })]
                            setOptions(opts);
                        }
                        }><div>{option.title}</div></button>
                )
            }
        </div>
    </div>
);

export default ToggleOptions;
